import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignLeftRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutAlignLeftRight"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 17H8.5V7H7V17ZM15.5 7V17H17V7H15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignLeftRight;
